// extracted by mini-css-extract-plugin
export default {"textContainer":"styles_textContainer__LhqId","small":"styles_small__GFu7X","medium":"styles_medium__ak6SP","large":"styles_large__woay6"};